(function (window) {
  function init() {
    const selects = document.querySelectorAll('.js-shipping-method-dropdown');

    Array.prototype.forEach.call(selects, function (select) {
      if (!select.dataset.shippingMethodChangeInit) {
        select.addEventListener('change', handleShippingMethodChange);
        select.dataset.shippingMethodChangeInit = true;
      }
    });
  }

  function handleShippingMethodChange(data) {
    // `data` param may be an event or the select element itself.
    const select = data.target || data;
    componentEvents.emitEvent('shipping-method-changed', [ select ]);
  }

  function handleShippingMethodUpdate() {
    const selects = document.querySelectorAll('.js-shipping-method-dropdown');
    Array.prototype.forEach.call(selects, function (select) {
      handleShippingMethodChange(select);
    });
  }

  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
    componentEvents.on('shipping-method-update', handleShippingMethodUpdate);
  }

  init();
})(this);
